import Vue from 'vue'
import Router from 'vue-router'

import FrontPage from '@/views/FrontPage.vue'
import MainPage from '@/views/MainPage.vue'
import ProjectPage from '@/views/ProjectPage.vue'
import PageNotFound from '@/views/PageNotFound.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        //{ path: '/', redirect: '/login' },
        {
            path: '/projects',
            name: 'projects',
            component: ProjectPage
        },
        {
            path: '/',
            name: 'front',
            component: FrontPage
        },
        {
            path: '/:cluster/:uuid?/:page?',
            name: 'main',
            component: MainPage
        },
        {
            path: '*',
            name: '404',
            component: PageNotFound
        }
        /*{
            path: '/template',
            name: 'templates',
            component: () => import('./views/TemplatesPage.vue')
        }*/
    ]
})
